import React from 'react';
import Icon from '../../common/Icon.react';

export default function SimpleLogicTerm(props) {
  const glyph = icon(props);
  return (
    <div
      className={`${props.showChoiceLabel ? '' : 'pull-right'} ${skipColor(
        props
      )}`}
      style={{ clear: 'right' }}
    >
      {glyph ? <Icon icon={glyph} /> : null}{' '}
      {props.showChoiceLabel && props.choiceLabel
        ? props.choiceLabel + ':'
        : ''}{' '}
      {props.description}
    </div>
  );
}

function icon({ type }) {
  if (type.match('Skip')) return 'skip';
  if (type.match('Soi')) return 'eye';
  return null;
}

function skipColor({
  exit,
  group,
  group_name,
  pages,
  page_to_show_id,
  skip_page_id,
  terminate,
  type,
}) {
  if (terminate) return 'terminate_color';
  if (exit) return 'finish_color';
  if (group && group_name) {
    const g = pages[group_name];
    return g ? g.skipColor : '';
  } else {
    const targetId = type.match('Skip') ? skip_page_id : page_to_show_id;
    const page = targetId ? pages[targetId] : null;
    return page ? page.skipColor : '';
  }
}
